import { IconButton, IconButtonProps } from '@material-ui/core';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import React from 'react';

type CopyClipboardButtonProps = {
  textoToClipboard: string;
} & IconButtonProps;

const CopyClipboardButton: React.FC<CopyClipboardButtonProps> = ({
  textoToClipboard,
  ...buttonProps
}) => {
  const onClickCopyButton = () => {
    navigator.clipboard.writeText(textoToClipboard);
  };
  return (
    <IconButton size="small" onClick={onClickCopyButton} {...buttonProps}>
      <FileCopyOutlinedIcon style={{ fontSize: '1.2rem' }} />
    </IconButton>
  );
};

export default CopyClipboardButton;
